export default __webpack_public_path__ + "static/media/img.62661aee.jpg";